import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import amplitude from 'amplitude-js';
import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Modal, ModalBody, ModalHeader } from 'reactstrap';
import smartlookClient from 'smartlook-client';
import { differenceInMinutes, parseISO } from 'date-fns';
import { FORCE_SETUP_OPEN, LOGGED_USER } from '../constants/ActionTypes';
import { VCS_ICON } from '../constants/api';
import { withQuickFixModal } from '../pages/CommitPage/components/QuickFixModal';
import { ghaNewInstallationLink } from '../utils/ghaLinks';
import CircleBar from './charts/CircleBar';
import Icon from './Icon';
import AppModal from './Modal';
import { withApollo } from '@apollo/client/react/hoc';
import { AwsRumContext } from './RumContext';
import { resolveUrlForRUM } from '../utils/resolveUrlForRUM';
import { defaultUrl } from '../pages/RepositoryPage/components/RepositoryDetail';
import ApiV2ModelContext from '../contexts/ApiV2ModelContext';
const DONT_OPEN_SETUP_MINUTES = 15;
class Setup extends Component {
    constructor() {
        super(...arguments);
        this.state = {
            open: false,
            expanded: 0,
        };
        this.handleExpandTask = (index) => {
            this.setState({
                expanded: index,
            });
        };
        this.handleCloseModal = (task = null) => {
            this.setState({ open: false });
            localStorage.setItem('setupClosed', new Date().toISOString());
            const eventName = 'setup-closed';
            const eventProperties = {};
            if (task) {
                eventProperties.taskTitle = task.title;
                eventProperties.taskCompleted = task.completed;
                this.props.history.push(task.link);
            }
            amplitude.getInstance().logEvent(eventName, eventProperties);
            smartlookClient.track(eventName, eventProperties);
        };
        this.handleOpenModal = () => {
            this.setState({ open: true });
            const eventName = 'setup-opened';
            amplitude.getInstance().logEvent(eventName);
            smartlookClient.track(eventName, {});
        };
        this.skipAddColleaguesStep = async () => {
            const { match } = this.props;
            try {
                const data = await this.context.updateUserInfo();
                this.props.dispatch({
                    type: LOGGED_USER,
                    payload: data.updateUserInfo,
                });
            }
            catch (error) {
                _jsx(AwsRumContext.Consumer, { children: awsRum => awsRum?.recordPageView(resolveUrlForRUM(match)) });
            }
        };
    }
    UNSAFE_componentWillReceiveProps(props) {
        const allowOpen = !localStorage.getItem('setupClosed') ||
            differenceInMinutes(new Date(), parseISO(localStorage.getItem('setupClosed'))) > DONT_OPEN_SETUP_MINUTES;
        if (!props.user.setupForceOpened &&
            props.user.firstLogin &&
            props.user.user &&
            props.user.user.email &&
            allowOpen) {
            this.setState({ open: true });
            props.dispatch({ type: FORCE_SETUP_OPEN });
        }
        else if (props.user.setupForceOpened && !this.state.open) {
            if (allowOpen) {
                this.setState({ open: true });
            }
            props.dispatch({ type: FORCE_SETUP_OPEN, payload: false });
        }
    }
    getListOfTasks() {
        const { match, repositories, t, user } = this.props;
        const vcsIcon = VCS_ICON[user.user.vcs];
        const hasNoAccess = this.hasNoAccess();
        const isURLMatched = new RegExp(defaultUrl).test(match.path);
        const vcsRepositories = repositories.list[match.params.vcs];
        const fullName = match.params.owner + '/' + match.params.repository;
        const repositoryId = isURLMatched && vcsRepositories
            ? vcsRepositories[fullName]?.id
            : null;
        const ghaLink = ghaNewInstallationLink(user.user, repositoryId);
        // @ts-expect-error TS2315: Type 'MouseEvent' is not generic.
        const ghaCallback = (event) => {
            event.preventDefault();
            event.stopPropagation();
            localStorage.setItem('loginRedirectUrl', this.props.match.url);
            location.href = ghaLink;
        };
        const taskGha = {
            title: t('setup.taskGha'),
            completed: !!user.user.ghaInstallations?.length,
            description: (_jsxs(_Fragment, { children: [_jsx("p", { children: t('setup.taskGhaDescription', {
                            siteName: t('siteName'),
                        }) }), _jsx("div", { className: "text-center", children: _jsxs("a", { className: "btn btn-primary btn-sm", href: ghaLink, onClick: ghaCallback, children: [_jsx(Icon, { name: `${vcsIcon} mr-2`, fixedWidth: true }), t('installGha')] }) })] })),
        };
        const webhookLink = '/repositories';
        const taskWebhook = {
            title: t('setup.taskWebhook'),
            completed: this.isWebhookRegistered(),
            link: webhookLink,
            description: (_jsxs(_Fragment, { children: [_jsxs("p", { children: [t('setup.taskWebhookDescription.intro'), _jsx("br", {}), t('setup.taskWebhookDescription.explanation', {
                                siteName: t('siteName'),
                            })] }), _jsx("div", { className: "text-center", children: _jsxs("a", { className: "btn btn-primary btn-sm", href: webhookLink, onClick: (event) => event.preventDefault(), children: [_jsx(Icon, { name: `${vcsIcon} mr-2`, fixedWidth: true }), t('registerWebhook')] }) })] })),
        };
        const hasNoAccessExtension = hasNoAccess ? 'NoAccess' : '';
        const organizationInviteLink = '/settings/organizations';
        const taskOrganizationInvite = {
            title: t('setup.taskOrganisationInvite'),
            completed: this.hasOwnTeam(),
            link: organizationInviteLink,
            description: (_jsxs(_Fragment, { children: [_jsx("p", { children: t('setup.taskOrganisationInviteDescription.intro' + hasNoAccessExtension, {
                            siteName: t('siteName'),
                        }) }), _jsx("p", { children: t('setup.taskOrganisationInviteDescription.explanation' + hasNoAccessExtension) }), _jsxs("div", { className: "text-center", children: [_jsxs("a", { className: "btn btn-primary btn-sm", href: organizationInviteLink, onClick: (event) => event.preventDefault(), children: [_jsx(Icon, { className: "mr-2", name: "plus" }), t('organizations.addMember')] }), _jsx("span", { className: "pl-2", children: t('or') }), _jsx("a", { className: "pl-2", onClick: (event) => {
                                    event.preventDefault();
                                    this.skipAddColleaguesStep();
                                }, children: t('skipThisStep') })] })] })),
        };
        const taskPermissions = {
            title: t('setup.taskPermissions', { siteName: t('siteName') }),
            description: t('setup.taskPermissionsDescription', {
                siteName: t('siteName'),
            }),
            completed: true,
            link: '/repositories',
        };
        if (hasNoAccess) {
            // @ts-expect-error TS2322: Type '{ title: any; completed: boolean; link: string; description: JSX.Element; }' is not assignable to type 'Task'.
            return [taskPermissions, taskOrganizationInvite, ...(user.user.gha ? [taskGha] : [taskWebhook])];
        }
        // @ts-expect-error TS2322: Type '{ title: any; completed: boolean; link: string; description: JSX.Element; }' is not assignable to type 'Task'.
        return [taskPermissions, ...(user.user.gha ? [taskGha] : [taskWebhook]), taskOrganizationInvite];
    }
    isWebhookRegistered() {
        const { repositories } = this.props;
        for (const vcs of Object.keys(repositories.list)) {
            for (const fullName of Object.keys(repositories.list[vcs])) {
                const repository = repositories.list[vcs][fullName];
                if (repository.active) {
                    return true;
                }
            }
        }
        return false;
    }
    hasNoAccess() {
        const { repositories } = this.props;
        for (const vcs of Object.keys(repositories.list)) {
            for (const fullName of Object.keys(repositories.list[vcs])) {
                const repository = repositories.list[vcs][fullName];
                if (repository.active || repository.admins?.length) {
                    return false;
                }
            }
        }
        return true;
    }
    hasOwnTeam() {
        const { largestOrganization, mostInvites, skipTaskOrganisationInvite } = this.props.user.user;
        if (skipTaskOrganisationInvite) {
            return true;
        }
        if (largestOrganization && largestOrganization.users > 1) {
            return true;
        }
        return mostInvites && mostInvites.users > 1;
    }
    renderModalBody(tasksCompleted, tasksToDo) {
        const { t } = this.props;
        const remaining = tasksToDo.length;
        const percentage = (tasksCompleted.length / (tasksCompleted.length + tasksToDo.length)) * 100;
        return (_jsxs("div", { className: "setup-modal", children: [_jsxs("div", { className: "d-flex mb-3", children: [_jsx("div", { className: "mr-4", children: _jsx(CircleBar, { percentage: percentage, amount: remaining, size: 2 }) }), _jsx("p", { className: "mt-3", children: t('setup.instructions', { siteName: t('siteName') }) })] }), _jsxs("h4", { className: "setup-modal__title", children: [_jsx(Icon, { className: "mr-2", name: "clipboard-list" }), t('setup.completeNow')] }), _jsx("div", { className: "list-group", children: tasksToDo.length
                        ? tasksToDo.map((task, index) => {
                            const isMain = this.state.expanded === index;
                            if (isMain) {
                                return (_jsxs("div", { className: "setup-modal__main-task", onClick: () => this.handleCloseModal(task), children: [_jsx("h5", { className: "mb-3", children: task.title }), _jsx("div", { className: "mb-1", children: task.description })] }, task.title));
                            }
                            return (_jsx("div", { className: "setup-modal__task", onClick: () => this.handleExpandTask(index), children: task.title }, task.title));
                        })
                        : null }), tasksCompleted.length ? (_jsxs(_Fragment, { children: [_jsxs("h4", { className: "setup-modal__title", children: [_jsx(Icon, { className: "mr-2", name: "check" }), t('setup.completedTasks')] }), _jsx("div", { className: "list-group", children: tasksCompleted.reverse().map((task) => {
                                return (_jsxs("div", { className: "setup-modal__task", onClick: () => this.handleCloseModal(task), children: [_jsx(Icon, { className: "text-success mr-2", name: "check-circle" }), " ", task.title] }, task.title));
                            }) })] })) : null] }));
    }
    renderModal(tasksCompleted, tasksToDo) {
        const { loading, t, user } = this.props;
        return (
        // @ts-expect-error TS2769: No overload matches this call.
        _jsxs(Modal, { isOpen: true, toggle: this.handleCloseModal, autoFocus: false, children: [_jsxs(ModalHeader, { toggle: this.handleCloseModal, children: [t('setup.title'), " ", t('siteName')] }), _jsx(ModalBody, { children: loading && !user.firstLogin ? (_jsx(Icon, { name: "spinner", pulse: true })) : (this.renderModalBody(tasksCompleted, tasksToDo)) })] }));
    }
    render() {
        const { loading, t, user } = this.props;
        if (user?.user.skipTaskOrganisationInvite) {
            return null;
        }
        if (loading && !user.firstLogin) {
            return null;
        }
        const taskList = this.getListOfTasks();
        const tasksCompleted = taskList.filter((task) => task.completed);
        const tasksToDo = taskList.filter((task) => !task.completed);
        const remaining = tasksToDo.length;
        const percentage = (tasksCompleted.length / taskList.length) * 100;
        if (percentage >= 100) {
            return null;
        }
        return (_jsxs("a", { className: "setup setup--bottom-left", onClick: this.handleOpenModal, children: [_jsx(CircleBar, { percentage: percentage, amount: remaining }), _jsxs("span", { className: "setup__info", children: [_jsxs("span", { className: "setup__title", children: [t('setup.title'), " ", t('siteName')] }), _jsx("span", { className: "setup__description", children: t('setup.remainingTask', { count: remaining }) })] }), this.state.open && remaining ? (_jsx(AppModal, { children: this.renderModal(tasksCompleted, tasksToDo) })) : null] }));
    }
}
Setup.contextType = ApiV2ModelContext;
Setup.defaultProps = {
    loading: true,
};
const mapStateToProps = (state) => ({
    repositories: state.repositories,
    user: state.user,
});
const mapDispatchToProps = (dispatch) => ({
    dispatch: dispatch,
});
export default withRouter(
// @ts-expect-error TS2345: Argument of type is not assignable to parameter of type
withQuickFixModal(connect(mapStateToProps, mapDispatchToProps)(withApollo(withTranslation()(Setup)))));
